<template>
    <div v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
</template>
<script>


export default {
  props: ['value'],
  
  computed: {
    loading() {
       return this.value;
    }
  },
  
};
</script>